import { useStateMachine } from 'little-state-machine';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FormGroup } from '../../../../../Components/FormGroup/FormGroup';
import updateAction from './updateAction';
import { FormattedMessage } from 'react-intl';
import { AiOutlineCloseCircle } from 'react-icons/ai';

function EducationLevel({
  register,
  errors,
  setValue,
  clearErrors,
  id,
  handleRemove,
  defaultValues
}) {
  const { state } = useStateMachine({ updateAction });
  const [edudationDetailsID, setEdudationDetailsID] = useState('');
  const handleEducationDetails = (e, educationDetails_id) => {
    setValue(educationDetails_id, e);
    clearErrors(educationDetails_id);
    setEdudationDetailsID(educationDetails_id);
  };
  const stateData = (state.education && state.education[id - 1]) || {};
  const [date, setDateArray] = useState([]);

  useEffect(() => {
    setValue(edudationDetailsID, state?.edudationDetailsID);
    const generateArrayOfYears = () => {
      var max = new Date().getFullYear();
      var min = 1950;
      var years = [];

      for (var i = min; i <= max; i++) {
        years.push({ label: i, value: i });
      }
      return years;
    };

    setDateArray(generateArrayOfYears);
  }, []);

  return (
    <div id={`education_details_component_${id}`} className="mt-2">
      <div className="row">
        <div className="col-md-2">
          <FormattedMessage id="select_education_level">
            {(placeholder) => (
              <FormGroup
                id={`education[${id}][educational_Level]`}
                type="select"
                options={[
                  { label: 'विद्यावारिधि', value: 'विद्यावारिधि' },
                  { label: 'स्नातकोत्तर', value: 'स्नातकोत्तर' },
                  { label: 'स्नातक', value: 'स्नातक' }
                ]}
                placeholder={placeholder[0]}
                onChange={(e) => {
                  handleEducationDetails(e, `education[${id}][educational_Level]`);
                }}
                defaultValue={
                  stateData.educational_Level ||
                  (defaultValues.level && {
                    label: defaultValues.level,
                    value: defaultValues.level
                  })
                }
                required={true}
                label={<FormattedMessage id="education_level" />}
                register={register}
                errorId="education_level"
                error={{
                  [`education[${id}][educational_Level]`]:
                    errors?.education &&
                    errors?.education[id] &&
                    errors?.education[id]?.educational_Level
                }}
              />
            )}
          </FormattedMessage>
        </div>
        <div className="col-md-2">
          <FormattedMessage id="select_education_completed_year">
            {(placeholder) => (
              <FormGroup
                id={`education[${id}][qualified_year]`}
                type="select"
                label={<FormattedMessage id="education_completed_year" />}
                options={date}
                placeholder={placeholder[0]}
                onChange={(e) => {
                  handleEducationDetails(e, `education[${id}][qualified_year]`);
                }}
                defaultValue={
                  stateData.qualified_year ||
                  (defaultValues.final_year && {
                    label: defaultValues.final_year,
                    value: defaultValues.final_year
                  })
                }
                register={register}
                required={true}
                errorId="qualified_year"
                // {{
                //   [`education[${id}][faculty]`]:
                //     errors?.education && errors?.education[id] && errors?.education[id]?.faculty
                // }}
                error={{
                  [`education[${id}][qualified_year]`]:
                    errors?.education &&
                    errors?.education[id] &&
                    errors?.education[id]?.qualified_year
                }}
              />
            )}
          </FormattedMessage>
        </div>
        <div className="col-md-2">
          <FormattedMessage id="select_education_sector">
            {(placeholder) => (
              <FormGroup
                id={`education[${id}][faculty]`}
                errorId="faculty"
                type="select"
                options={[
                  { label: 'कानुन', value: 'Law' },
                  { label: 'कृषि', value: 'Agriculture' },
                  { label: 'क्षेत्रीय विकास', value: 'Regional Development' },
                  { label: 'ग्रामीण विकास', value: 'Rural Development' },
                  { label: 'जलबायु विज्ञान', value: 'Climate Science' },
                  { label: 'तथ्यांक शास्त्र', value: 'Statistics' },
                  { label: 'कानुन', value: 'Law' },
                  { label: 'पशु', value: 'Animals' },
                  { label: 'प्राकृतिक श्रोत व्यवस्थापन', value: 'Natural resource Management' },
                  { label: 'भौतिक पूर्वाधार', value: 'Physical Infrastructure' },
                  { label: 'मानविकी', value: 'Humanities' },
                  { label: 'वन वातावरण', value: 'Forest Environment' },
                  { label: 'वाणिज्य शास्त्र', value: 'Commerce Science' },
                  { label: 'वातावरण इन्जिनियरिंग', value: 'Environmental Engineering' },
                  { label: 'विकास व्यवस्थापन', value: 'Development Management' },
                  { label: 'अन्य', value: 'others' }
                ]}
                placeholder={placeholder[0]}
                defaultValue={
                  stateData.faculty ||
                  (defaultValues.sector && {
                    label: defaultValues.sector,
                    value: defaultValues.sector
                  })
                }
                onChange={(e) => {
                  handleEducationDetails(e, `education[${id}][faculty]`);
                }}
                label={<FormattedMessage id="education_sector" />}
                register={register}
                required={true}
                error={{
                  [`education[${id}][faculty]`]:
                    errors?.education && errors?.education[id] && errors?.education[id]?.faculty
                }}
              />
            )}
          </FormattedMessage>
        </div>
        <div className="col-md-2">
          <FormattedMessage id="select_secured_grade">
            {(placeholder) => (
              <FormGroup
                id={`education[${id}][secured_grade]`}
                type="select"
                placeholder={placeholder[0]}
                options={[
                  { label: 'प्रथम श्रेणी', value: 'First Class' },
                  { label: 'दितिय श्रेणी', value: 'Second Class' },
                  { label: 'तृतीय श्रेणी', value: 'Third Class' }
                ]}
                onChange={(e) => {
                  handleEducationDetails(e, `education[${id}][secured_grade]`);
                }}
                label={<FormattedMessage id="secured_grade" />}
                defaultValue={
                  stateData.secured_grade ||
                  (defaultValues.grade && {
                    label: defaultValues.grade,
                    value: defaultValues.grade
                  })
                }
                register={register}
                required={true}
                errorId="secured_grade"
                error={{
                  [`education[${id}][secured_grade]`]:
                    errors?.education &&
                    errors?.education[id] &&
                    errors?.education[id]?.secured_grade
                }}
              />
            )}
          </FormattedMessage>
        </div>
        <div className="col-md-1 d-flex align-items-end">
          {id === 1 ? null : (
            <span className="d-flex justify-content-end">
              <Button
                variant="outline-danger"
                className="d-flex justify-content-center align-items-center"
                onClick={() => handleRemove(id)}>
                <AiOutlineCloseCircle className="me-1" />
                <FormattedMessage id="remove" />
              </Button>
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default EducationLevel;
